import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isTermsDropdownOpen, setIsTermsDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => {
      // when closing the menu, also close the terms dropdown
      if (prev) setIsTermsDropdownOpen(false);
      return !prev;
    });
  };

  const location = useLocation();
  // close mobile menu and dropdown on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsMenuOpen(false);
    setIsTermsDropdownOpen(false);
  }, [location.pathname]);

  // keep mobile menu closed when window is resized to large screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMenuOpen(false);
        setIsTermsDropdownOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // helper to close everything when clicking an internal link
  const handleNavLinkClick = () => {
    setIsMenuOpen(false);
    setIsTermsDropdownOpen(false);
  };

  return (
    <>
      {/* ======= Header =======*/}
      <header
        className="fbs__net-navbar navbar navbar-expand-lg dark !z-[20]"
        aria-label="navbar"
      >
        <div className="container d-flex align-items-center justify-content-between">
          <div className="flex items-center gap-2">
            <a className="navbar-brand w-auto" href="/">
              <img
                className="logo dark img-fluid w-[200px] desktop-logo"
                src="assets/images/logo.png"
                alt="Brand Logo"
              />
              <img
                className="logo dark img-fluid mobile-logo"
                src="assets/images/mobile-logo.png"
                alt="Brand Logo"
              />
            </a>

          </div>

          <div
            className="offcanvas offcanvas-start w-75"
            id="fbs__net-navbars"
            tabIndex={-1}
            aria-labelledby="fbs__net-navbarsLabel"
          >
            <div className="offcanvas-header">
              <div className="offcanvas-header-logo">
                <a
                  className="logo-link"
                  id="fbs__net-navbarsLabel"
                  href="/"
                >
                  {/* logo dark*/}
                  <img
                    className="logo dark img-fluid w-[160px]"
                    src="assets/images/logo.png"
                    alt="Brand Logo"
                  />
                </a>
              </div>
              <button
                className="btn-close btn-close-black"
                type="button"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            <div className="offcanvas-body align-items-lg-center">
              <ul className="navbar-nav nav me-auto ps-lg-5 mb-2 mb-lg-0">
                <li className="nav-item">
                  <a
                    className="nav-link scroll-link active"
                    aria-current="page"
                    href="/"
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link scroll-link" href="/plans">
                    Plans
                  </a>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Terms & Policies <i className="bi bi-chevron-down" />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="nav-link scroll-link dropdown-item" href="term-of-use">
                        Term & Conditions
                      </a>
                    </li>
                    <li>
                      <a className="nav-link scroll-link dropdown-item" href="/shipping-delivery-policy">
                        Shipping and Delivery
                      </a>
                    </li>
                    <li>
                      <a className="nav-link scroll-link dropdown-item" href="/privacy-policy">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a className="nav-link scroll-link dropdown-item" href="/cancellation-policy">
                        Cancellation Policy
                      </a>
                    </li>
                    <li>
                      <a className="nav-link scroll-link dropdown-item" href="/service-protocol-terms">
                        Service Protocol Terms
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a className="nav-link scroll-link" href="/contact">
                    Contact
                  </a>
                </li>
                <li className="nav-item md:hidden">
                  <a className="nav-link scroll-link" href="login.html">
                    Login
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* End offcanvas*/}
          <div className="ms-auto w-auto flex gap-4">
            <div
              className="logos desktop-logo"
              data-aos="fade-in"
              data-aos-delay={400}
            >
              <span className="logos-title text-uppercase d-block text-[12px] font-semibold text-center">
                In association with
              </span>
              <div className="logos-images d-flex gap-4 align-items-center">
                <img
                  className="img-fluid js-img-to-inline-svg"
                  src="assets/images/assoc.png"
                  alt="Company 1"
                  style={{ width: 180 }}
                />
              </div>
            </div>
            <div className="header-social d-flex align-items-center gap-1">
              <a className="btn btn-primary py-2" href="login.html">
                Login
              </a>
              <button
                className="fbs__net-navbar-toggler justify-content-center align-items-center ms-auto"
                data-bs-toggle="offcanvas"
                data-bs-target="#fbs__net-navbars"
                aria-controls="fbs__net-navbars"
                aria-label="Toggle navigation"
                aria-expanded="false"
              >
                <svg
                  className="fbs__net-icon-menu"
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1={21} x2={3} y1={6} y2={6} />
                  <line x1={15} x2={3} y1={12} y2={12} />
                  <line x1={17} x2={3} y1={18} y2={18} />
                </svg>
                <svg
                  className="fbs__net-icon-close"
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>
      {/* End Header*/}


    </>
  );
};

export default Header;
